(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["anchor-navigation"] && !Shopify.designMode) return;
  try {
    /**
   * Anchor Navigation Component
   * Two main functions:
   * 1. Show/hide fixed navigation on scroll
   * 2. Update active link states when scrolling to sections
   */
  (function () {
    'use strict';

    const jumpNav = document.querySelector('[data-jump-nav]');
    if (!jumpNav) return;

    const staticNav = jumpNav.querySelector('[data-scroll-nav]:not([data-fixed-nav])');
    const fixedNav = jumpNav.querySelector('[data-fixed-nav]');

    // Get links from BOTH navigations separately to ensure we update both
    const staticLinks = staticNav.querySelectorAll('[data-scroll-link]');
    const fixedLinks = fixedNav.querySelectorAll('[data-scroll-link]');
    const allLinks = [...staticLinks, ...fixedLinks];

    if (!staticNav || !fixedNav || allLinks.length === 0) return;

    // Collect all target sections (use staticLinks to avoid duplicates)
    const sections = new Map();
    staticLinks.forEach((link) => {
      const href = link.getAttribute('href');
      if (href && href.startsWith('#')) {
        const targetId = href.substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          sections.set(targetId, targetElement);
        }
      }
    });

    // Calculate total offset including header and navigation
    const stickyHeader = document.querySelector('.shopify-section-header-sticky');
    const header = document.querySelector('sticky-header') || document.querySelector('.header-wrapper');
    let headerHeight = 0;
    let fixedNavHeight = 0;
    let ticking = false;

    // Get header height dynamically
    function getHeaderHeight() {
      if (stickyHeader) {
        headerHeight = stickyHeader.offsetHeight || 0;
      } else if (header) {
        headerHeight = header.offsetHeight || 0;
      }
      return headerHeight;
    }

    // Get fixed navigation height dynamically
    function getFixedNavHeight() {
      if (fixedNav) {
        fixedNavHeight = fixedNav.offsetHeight || 0;
      }
      return fixedNavHeight;
    }

    // Initialize header and fixed nav heights
    getHeaderHeight();
    getFixedNavHeight();

    /**
     * Function: Show/hide fixed navigation based on scroll position
     */
    function toggleFixedNav() {
      const staticNavBottom = staticNav.getBoundingClientRect().bottom;

      if (staticNavBottom <= 0) {
        // Static nav is scrolled out of view, show fixed nav
        fixedNav.removeAttribute('hidden');
      } else {
        // Static nav is still visible, hide fixed nav
        fixedNav.setAttribute('hidden', '');
      }
    }

    /**
     * Function: Update active link based on current scroll position
     */
    function updateActiveLinks() {
      const scrollPosition = window.pageYOffset;
      // Total offset: header height + fixed navigation height + small buffer
      const buffer = 5; // 10px buffer to ensure proper activation timing
      const totalOffset = headerHeight + fixedNavHeight + buffer;
      let currentSection = null;

      // Convert sections Map to array for easier processing
      const sectionsArray = Array.from(sections.entries());

      // Find the section that is currently at the top of the viewport
      // The active section is the one whose top is closest to the total offset point
      for (let i = 0; i < sectionsArray.length; i++) {
        const [id, section] = sectionsArray[i];
        const sectionTop = section.getBoundingClientRect().top + window.pageYOffset;

        // Check if this section's top is at or just past the total offset point
        if (scrollPosition + totalOffset >= sectionTop) {
          currentSection = id;
        } else {
          // If we haven't reached this section yet, stop checking
          // The previous section (if any) should remain active
          break;
        }
      }

      // Update all links (both static and fixed navigation)
      let activeLink = null;
      allLinks.forEach((link) => {
        const href = link.getAttribute('href');
        const isActive = currentSection && href === `#${currentSection}`;

        // Set both aria-current for accessibility and class for styling
        if (isActive) {
          link.setAttribute('aria-current', 'true');
          link.classList.add('active');
          activeLink = link;
        } else {
          link.setAttribute('aria-current', 'false');
          link.classList.remove('active');
        }
      });

      // Scroll to ensure the active link is fully visible
      if (activeLink) {
        const sideScroller = activeLink.closest('[data-side-scroll]');
        if (sideScroller) {
          const containerWidth = sideScroller.clientWidth;
          const itemLeft = activeLink.offsetLeft;
          const itemWidth = activeLink.clientWidth;
          const scrollLeft = sideScroller.scrollLeft;

          // Calculate the visible range
          const itemRight = itemLeft + itemWidth;
          const visibleLeft = scrollLeft;
          const visibleRight = scrollLeft + containerWidth;

          // Add padding to ensure item isn't at the very edge
          const padding = 20;

          // Determine scroll position
          let targetScroll = scrollLeft;

          // If item is cut off on the right
          if (itemRight + padding > visibleRight) {
            targetScroll = itemRight + padding - containerWidth;
          }
          // If item is cut off on the left
          else if (itemLeft - padding < visibleLeft) {
            targetScroll = itemLeft - padding;
          }

          // Only scroll if needed
          if (targetScroll !== scrollLeft) {
            sideScroller.scrollTo({
              left: Math.max(0, targetScroll),
              behavior: 'smooth'
            });
          }
        }
      }
    }

    /**
     * Handle scroll event with requestAnimationFrame for performance
     */
    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          toggleFixedNav();
          updateActiveLinks();
          ticking = false;
        });
        ticking = true;
      }
    }

    /**
     * Handle smooth scroll on link click
     */
    function handleLinkClick(event) {
      event.preventDefault();

      const href = this.getAttribute('href');
      if (!href || !href.startsWith('#')) return;

      const targetId = href.substring(1);
      const targetElement = document.getElementById(targetId);
      if (!targetElement) return;

      // Calculate scroll position with offset (header height + fixed nav height)
      const totalOffset = headerHeight + fixedNavHeight;
      const targetPosition = targetElement.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = targetPosition - totalOffset;

      // Smooth scroll to target
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth',
      });

      // Update URL hash without jumping
      if (history.pushState) {
        history.pushState(null, null, href);
      }

      // Update active links after a short delay to ensure smooth scroll completes
      setTimeout(() => {
        updateActiveLinks();
      }, 1000);
    }

    // Attach click handlers to all scroll links
    allLinks.forEach((link) => {
      link.addEventListener('click', handleLinkClick);
    });

    // Attach scroll listener
    window.addEventListener('scroll', onScroll, { passive: true });

    // Initial check on page load
    toggleFixedNav();
    updateActiveLinks();

    // Recalculate heights after images and content load
    window.addEventListener('load', () => {
      getHeaderHeight();
      getFixedNavHeight();
      updateActiveLinks();
    });

    // Recalculate heights on resize (in case header or nav changes size)
    let resizeTimeout;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        getHeaderHeight();
        getFixedNavHeight();
      }, 250);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bakers-sticky-scrollable-content"] && !Shopify.designMode) return;
  try {
    // Move navigation buttons from blocks to the navigation list
  function moveButtonsToNavigation(stickyScrollableSection) {
    const navElement = stickyScrollableSection.querySelector('.sticky-scrollable-tabbed__nav');
    const navList = stickyScrollableSection.querySelector('.sticky-scrollable-tabbed__nav-list');
    const tempButtons = stickyScrollableSection.querySelectorAll('.temp-nav-button');

    if (!navList) return;

    // Hide navigation if no temp buttons found
    if (!tempButtons.length) {
      if (navElement) {
        navElement.style.display = 'none';
      }
      return;
    }

    // Show navigation if temp buttons exist
    if (navElement) {
      navElement.style.display = '';
    }

    // Clear existing nav content
    navList.innerHTML = '';

    // Move each button to navigation
    tempButtons.forEach((button) => {
      // Create list item wrapper
      const listItem = document.createElement('li');
      listItem.className = 'sticky-scrollable-tabbed__nav-item';

      // Check if button has jump-button class and add sticky-scrollable-tabbed__jump class to list item
      if (button.classList.contains('jump-button')) {
        listItem.classList.add('sticky-scrollable-tabbed__jump');
      }

      // Clone the button and remove temp class
      const navButton = button.cloneNode(true);
      navButton.classList.remove('temp-nav-button', 'hidden');

      // Get button style from section settings
      const buttonStyle = stickyScrollableSection.dataset.buttonStyle || 'button--primary';
      navButton.classList.add(buttonStyle);

      // Append to nav list
      listItem.appendChild(navButton);
      navList.appendChild(listItem);

      // Remove original temp button
      button.remove();
    });
  }

  // Check initial viewport state and set active button
  function setInitialActiveState(stickyScrollableSection) {
    const navButtons = stickyScrollableSection.querySelectorAll('.sticky-scrollable-tabbed__nav-button');
    const contentSections = stickyScrollableSection.querySelectorAll('.sticky-scrollable-tabbed__content-section');

    if (!navButtons.length || !contentSections.length) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const windowHeight = window.innerHeight;

    // Get scroll offset from CSS variable or use default
    const scrollOffsetValue = getComputedStyle(stickyScrollableSection).getPropertyValue('--scroll-offset').trim();
    const scrollOffset = scrollOffsetValue ? parseInt(scrollOffsetValue.replace('px', '')) : 100;

    let activeSection = null;
    let maxVisibility = 0;

    contentSections.forEach((section) => {
      const rect = section.getBoundingClientRect();
      const sectionTop = rect.top + scrollTop;
      const sectionBottom = sectionTop + rect.height;

      // Calculate how much of the section is visible in viewport
      const viewportTop = scrollTop + scrollOffset;
      const viewportBottom = scrollTop + windowHeight;

      const visibleTop = Math.max(sectionTop, viewportTop);
      const visibleBottom = Math.min(sectionBottom, viewportBottom);
      const visibleHeight = Math.max(0, visibleBottom - visibleTop);
      const visibilityRatio = visibleHeight / rect.height;

      if (visibilityRatio > maxVisibility) {
        maxVisibility = visibilityRatio;
        activeSection = section;
      }
    });

    if (activeSection) {
      const sectionId = activeSection.id;
      const targetButton = stickyScrollableSection.querySelector(`[data-scroll-to="${sectionId}"]`);

      if (targetButton) {
        // Remove active class from all buttons
        navButtons.forEach((btn) => btn.classList.remove('active'));
        // Add active class to correct button
        targetButton.classList.add('active');
      }
    }
  }

  document.addEventListener('DOMContentLoaded', function () {
    const stickyScrollableSections = document.querySelectorAll('.sticky-scrollable-tabbed');
    if (!stickyScrollableSections.length) return;

    // Initialize each sticky scrollable section instance
    stickyScrollableSections.forEach((stickyScrollableSection) => {
      // Move buttons from blocks to navigation
      moveButtonsToNavigation(stickyScrollableSection);

      // Initialize scroll tracking and interactions after navigation is populated
      initializeScrollTracking(stickyScrollableSection);

      // Set initial active state after buttons are moved and tracking is initialized
      setTimeout(() => {
        setInitialActiveState(stickyScrollableSection);
      }, 150);
    });

    // Handle URL hash on page load (for shared links) - only needs to run once
    if (window.location.hash) {
      const hash = window.location.hash.substring(1); // Remove the #

      // Check all sections for the target anchor
      let targetSection = null;
      let targetSectionContainer = null;

      for (const stickyScrollableSection of stickyScrollableSections) {
        const foundSection = findSectionByAnchor(stickyScrollableSection, hash);
        if (foundSection) {
          targetSection = foundSection;
          targetSectionContainer = stickyScrollableSection;
          break;
        }
      }

      if (targetSection && targetSectionContainer) {
        setTimeout(() => {
          // Get scroll offset from CSS variable or use default
          const scrollOffsetValue = getComputedStyle(targetSectionContainer).getPropertyValue('--scroll-offset').trim();
          const scrollOffset = scrollOffsetValue ? parseInt(scrollOffsetValue.replace('px', '')) : 100;

          const offsetTop = targetSection.offsetTop - scrollOffset;

          // Detect user's motion preference for initial hash scroll
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';

          window.scrollTo({
            top: Math.max(0, offsetTop),
            behavior: scrollBehavior,
          });
        }, 100);
      }
    }
  });

  // Initialize scroll tracking and button interactions
  function initializeScrollTracking(stickyScrollableSection) {
    // Get the buttons and sections AFTER they've been created/updated
    const navButtons = stickyScrollableSection.querySelectorAll('.sticky-scrollable-tabbed__nav-button');
    const contentSections = stickyScrollableSection.querySelectorAll('.sticky-scrollable-tabbed__content-section');

    if (!navButtons.length || !contentSections.length) {
      return;
    }

    // Intersection Observer for tracking active sections
    const observerOptions = {
      root: null,
      rootMargin: '-20% 0px -50% 0px',  // Active zone: 20% from top to 50% from bottom
      threshold: 0,  // Any amount visible triggers (works with all section sizes)
    };

    // Track all currently intersecting sections
    const intersectingSections = new Set();

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const sectionId = entry.target.id;

        if (entry.isIntersecting) {
          // Add to intersecting sections
          intersectingSections.add(entry.target);
        } else {
          // Remove from intersecting sections
          intersectingSections.delete(entry.target);
        }
      });

      // Find the section that's highest on the page (closest to top)
      let topMostSection = null;
      let topMostPosition = Infinity;

      intersectingSections.forEach((section) => {
        const rect = section.getBoundingClientRect();
        if (rect.top < topMostPosition) {
          topMostPosition = rect.top;
          topMostSection = section;
        }
      });

      // Update active button based on topmost section
      if (topMostSection) {
        const targetButton = stickyScrollableSection.querySelector(`[data-scroll-to="${topMostSection.id}"]`);

        if (targetButton) {
          // Remove active class from all buttons
          navButtons.forEach((btn) => btn.classList.remove('active'));
          // Add active class to current button
          targetButton.classList.add('active');
        }
      }
    }, observerOptions);

    // Observe all content sections
    contentSections.forEach((section) => {
      observer.observe(section);
    });

    // Smooth scroll on button click
    navButtons.forEach((button) => {
      button.addEventListener('click', function (e) {
        e.preventDefault();

        // Handle jump buttons with href attribute
        if (this.classList.contains('jump-button')) {
          const href = this.getAttribute('href');
          if (href && href.startsWith('#')) {
            const targetId = href.substring(1);
            const targetElement = document.getElementById(targetId);

            if (targetElement) {
              // Get scroll offset from CSS variable or use default (same as other navigation)
              const scrollOffsetValue = getComputedStyle(stickyScrollableSection)
                .getPropertyValue('--scroll-offset')
                .trim();
              const scrollOffset = scrollOffsetValue ? parseInt(scrollOffsetValue.replace('px', '')) : 100;

              // Calculate scroll position with offset (same as other navigation)
              const rect = targetElement.getBoundingClientRect();
              const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const offsetTop = rect.top + currentScrollTop - scrollOffset;

              // Detect user's motion preference
              const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
              const scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';

              // Only update URL hash if it's different (prevent duplicate history)
              if (href !== window.location.hash) {
                if (history.pushState) {
                  history.pushState(null, null, href);
                }
              }

              window.scrollTo({
                top: Math.max(0, offsetTop),
                behavior: scrollBehavior,
              });
            }
          } else {
            // Fallback to normal navigation for non-hash hrefs
            window.location.href = href;
          }
          return;
        }

        // Handle regular navigation buttons with data-scroll-to attribute
        const targetId = this.getAttribute('data-scroll-to');
        const customAnchor = this.getAttribute('data-anchor-id');
        const targetSection = document.getElementById(targetId);

        if (targetSection) {
          // Immediately update active state for clicked button
          navButtons.forEach((btn) => btn.classList.remove('active'));
          this.classList.add('active');

          // Get scroll offset from CSS variable or use default
          const scrollOffsetValue = getComputedStyle(stickyScrollableSection)
            .getPropertyValue('--scroll-offset')
            .trim();
          const scrollOffset = scrollOffsetValue ? parseInt(scrollOffsetValue.replace('px', '')) : 100;

          // Calculate the absolute position of the target section
          const rect = targetSection.getBoundingClientRect();
          const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const offsetTop = rect.top + currentScrollTop - scrollOffset;

          // Detect user's motion preference
          const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const scrollBehavior = prefersReducedMotion ? 'auto' : 'smooth';

          // Update URL hash with custom anchor (for sharing)
          const hashToUse = customAnchor || targetId;
          const newHash = '#' + hashToUse;

          // Only create new history entry if hash is different, otherwise replace
          if (newHash !== window.location.hash) {
            history.pushState(null, null, newHash);
          } else {
            history.replaceState(null, null, newHash);
          }

          window.scrollTo({
            top: Math.max(0, offsetTop), // Ensure we don't scroll to negative position
            behavior: scrollBehavior,
          });
        }
      });

      // Keyboard navigation
      button.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          this.click();
        }
      });
    });
  }

  // Helper function to find section by custom anchor ID
  function findSectionByAnchor(container, anchorId) {
    const contentSections = container.querySelectorAll('.sticky-scrollable-tabbed__content-section');

    for (const section of contentSections) {
      // First check if section ID matches directly
      if (section.id === anchorId) {
        return section;
      }

      // Then check for custom anchor in group wrapper (if exists)
      const groupWrapper = section.querySelector('.bakers-sticky-group-wrapper');
      if (groupWrapper) {
        const customAnchor = groupWrapper.dataset.anchorLabel;
        if (customAnchor && customAnchor.trim() === anchorId) {
          return section;
        }
      }
    }

    return null;
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["blog-social-sharing"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function() {
    const copyButtons = document.querySelectorAll('.blog-social-sharing__link--copy');
    
    copyButtons.forEach(button => {
      button.addEventListener('click', async function(e) {
        e.preventDefault();
        const url = this.getAttribute('data-copy-url');
        
        try {
          await navigator.clipboard.writeText(url);
          
          // Add copied class for visual feedback
          this.classList.add('copied');
          
          // Remove copied class after 2 seconds
          setTimeout(() => {
            this.classList.remove('copied');
          }, 2000);
          
        } catch (err) {
          // Fallback for older browsers
          const textArea = document.createElement('textarea');
          textArea.value = url;
          document.body.appendChild(textArea);
          textArea.select();
          document.execCommand('copy');
          document.body.removeChild(textArea);
          
          // Add copied class for visual feedback
          this.classList.add('copied');
          
          // Remove copied class after 2 seconds
          setTimeout(() => {
            this.classList.remove('copied');
          }, 2000);
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["recipe-sharing"] && !Shopify.designMode) return;
  try {
    // Copy link functionality
  document.addEventListener('DOMContentLoaded', function () {
    const copyButtons = document.querySelectorAll('.recipe-sharing__button--copy[data-copy-url]');

    copyButtons.forEach((button) => {
      const messageElement = button.querySelector('.recipe-sharing__copy-message');
      
      let messageTimeout;

      // Copy functionality
      button.addEventListener('click', async function () {
        const url = this.dataset.copyUrl;

        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(url);
          } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand('copy');
            textArea.remove();
          }

          // Show success message
          if (messageElement) {
            clearTimeout(messageTimeout);
            messageElement.hidden = false;
            messageTimeout = setTimeout(() => {
              messageElement.hidden = true;
            }, 2000);
          }
        } catch (err) {
          console.error('Failed to copy link:', err);
          // Show error feedback
          if (messageElement) {
            messageElement.textContent = 'Copy failed. Please try again.';
            messageElement.hidden = false;
            setTimeout(() => {
              messageElement.hidden = true;
            }, 3000);
          }
        }
      });

      // Hide message on Escape key
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && messageElement && !messageElement.hidden) {
          clearTimeout(messageTimeout);
          messageElement.hidden = true;
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
